var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "td",
    {
      key: _vm.isSelected,
      staticClass: "tube-container",
      class: [
        { selected: _vm.isSelected && _vm.tubeNumber },
        { borders: !!_vm.getHeight() }
      ],
      style: { height: _vm.getHeight(), "background-color": _vm.getColor() },
      on: {
        click: function($event) {
          return _vm.$emit("click")
        },
        contextmenu: function($event) {
          return _vm.$emit("contextmenu", $event)
        }
      }
    },
    [_vm._v("\n  " + _vm._s(_vm.tubeNumber) + "\n")]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3bcab306", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3bcab306","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splicing/ObjectTable/TableDataTube.vue
// module id = null
// module chunks = 